/* * * VUE.JS 2.5+ component files * * */

module.exports = ( Vue ) => { 
    Vue.component('contractor-listing',  require('./components/Contractors/Listing.vue').default );
  	Vue.component('contractor-projects', require('./components/Contractors/Projects.vue').default );

    Vue.component('breadcrumbs',        require('./components/Breadcrumbs.vue').default );
    Vue.component('videa-calculator',   require('./components/Calculator.vue').default );
    Vue.component('register',           require('./Auth/Register.vue').default );
    Vue.component('form-validator',     require('../admin/plugins/Validator/Validator.vue').default );
    Vue.component('dropzone',           require('../admin/plugins/Dropzone/Dropzone.vue').default );
    Vue.component('auth-user',          require('./Auth/NewAuth.vue').default );
    Vue.component('project-files',      require('./components/Projects/Files.vue').default );
    Vue.component('project-listing',    require('./components/Projects/Listing.vue').default );
    Vue.component('loader',             require('../admin/components/Loader.vue').default );
  	Vue.component('loading-div', 		require('../common/components/LoadingDiv.vue').default );
  	Vue.component('owl-carousel', 		require('../admin/plugins/OwlCarousel/OwlCarousel.vue').default );
  	Vue.component('last-project-car',   require('./components/Elements/LastProjectCarousel.vue').default );
    Vue.component('one-project-car',    require('./components/Elements/OneProjectCarousel.vue').default );
    Vue.component('project-form',       require('./components/Projects/ProjectForm.vue').default );
    Vue.component('user-stats',         require('./components/Users/UserStats.vue').default );
    // Vue.component('file-edit-modal',    require('./components/FileEditModal.vue').default );
    Vue.component('user-disabled-notifs',    require('./components/UserDisabledNotifs.vue').default );

    Vue.component('img-field',          require('../admin/plugins/ImageHandler/Handler.vue').default );

    //The project record for videa clients
    Vue.component('phase-terms',        require('./components/Record/PhaseTerms.vue').default );
    Vue.component('project-record',     require('./components/Record/Index.vue').default );
    Vue.component('phase-apply',        require('./components/Projects/Apply/Index.vue').default );
    Vue.component('rate-sidebar',       require('./components/Projects/RateSidebar.vue').default );
    Vue.component('phase-timer',        require('./components/Record/Phase/PhaseTimer.vue').default );
    Vue.component('file-grid',          require('./components/FileGrid.vue').default );
    Vue.component('user-rating',        require('./components/UserRating.vue').default );
    Vue.component('contact-form',        require('./components/ContactForm.vue').default );

  	Vue.component('project-messages', 	require('./components/Record/Messages.vue').default );

    //Common components used in admin and public
    Vue.component('worker-review',        require('../common/components/WorkerReview.vue').default );
    Vue.component('phase-decline-modal',  require('../common/components/PhaseDeclineModal.vue').default );
    Vue.component('paginator',            require('../common/components/Paginator.vue').default );
}